<template>
  <section v-if="records > 0 && records > pagesize" class="container d-flex align-items-center justify-content-center mb-5">
    <button class="botonespaginacion d-flex justify-content-center align-items-center rounded-2 me-2"
            :class="{ disabled: prevDisabled, active: !prevDisabled }"
            @click="prevPage()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.25 12H3.75" :stroke="prevDisabled ? '#6D737A' : '#fff'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.5 5.25L3.75 12L10.5 18.75" :stroke="prevDisabled ? '#6D737A' : '#fff'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </button>
    <button v-for="page in pages" class="botonespaginacion fw-bold d-flex align-items-center justify-content-center rounded-2 me-2"
            :class="{active: value === page}"
            @click="setPage(page)">
      {{ page}}
    </button>
    <button class="botonespaginacion d-flex align-items-center justify-content-center rounded-2"
            :class="{disabled: nextDisabled, active: !nextDisabled }"
            @click="nextPage()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 12H20.25" :stroke="nextDisabled ? '#6D737A' : '#fff'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.5 5.25L20.25 12L13.5 18.75" :stroke="nextDisabled ? '#6D737A' : '#fff'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </button>
  </section>
</template>

<script>
export default {
  props: {
    value: Number, // pagina actual, utilizado por v-model
    records: Number, // total de registros
    from: Number,
    to: Number,
    pagesize: {
      // tamaño de cada pagina
      type: Number,
      default: 50,
    },
  },
  events: ['paginate'],
  data() {
    return {
      lastPageEnabled: false,
      next: false,
    }
  },
  mounted() {},
  methods: {
    firstPage() {
      this.emitPageChange(1)
    },
    prevPage() {
      if (!this.prevDisabled) {
        this.emitPageChange(this.value - 1)
      }
    },
    setPage(page) {
      this.emitPageChange(page)
    },
    nextPage() {
      if (!this.nextDisabled) {
        this.emitPageChange(this.value + 1)
      }
    },
    lastPage() {
      this.emitPageChange(this.numPages)
    },
    emitPageChange(newValue) {
      this.$emit('input', newValue)
      this.$emit('paginate', newValue)
    },
  },
  computed: {
    prevDisabled() {
      return this.value === 1
    },
    nextDisabled() {
      return this.value === this.pages[this.pages.length - 1]
    },
    numPages() {
      return Math.ceil(this.records / this.pagesize)
    },
    pages() {
      let pages = []
      let firstPage = this.value - 5
      if (firstPage < 1) {
        firstPage = 1
      }
      let lastPage = firstPage + 8
      if (lastPage > this.numPages) {
        lastPage = this.numPages
      }
      for (let i = firstPage; i <= lastPage; i++) {
        pages.push(i)
      }
      return pages
    },
  },
}
</script>

<style scoped lang="scss">
.botonespaginacion{
    &.disabled{
        cursor: not-allowed;
        &:active{
            background: #F5EFEE;
        }
    }
}
</style>
